import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultIncomingOrdersStatistics, IncomingOrdersStatistics } from "../../models/responses/incomingOrdersStatistics";

export interface StatisticsState {
    incomingOrdersList: IncomingOrdersStatistics;
    isWaitingIncomingOrderResponse: boolean;
}

const initialState: StatisticsState = {
    incomingOrdersList: defaultIncomingOrdersStatistics,
    isWaitingIncomingOrderResponse: false
};

const statisticsSlice = createSlice({
    name: 'statistic',
    initialState,
    reducers: {
        setIncomingOrders: (state, action: PayloadAction<{
            incomingOrders: IncomingOrdersStatistics;
        }>) => {
            state.incomingOrdersList = action.payload.incomingOrders || defaultIncomingOrdersStatistics;
            return state;
        },        
        setIsWaitingIncomingOrderResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingIncomingOrderResponse = action.payload;
        },
    },
});

export const {
    setIncomingOrders,
    setIsWaitingIncomingOrderResponse,
} = statisticsSlice.actions;

export default statisticsSlice.reducer;